import { useFormikContext } from "formik";
import { Chip, Stack } from "@mui/material"
import { Beer, Coffee, Utensils } from "lucide-react";
import { OnboardingFormValues } from "../Onboarding";

const OrganizationTypeStep = () => {
    const { values, setFieldValue } = useFormikContext<OnboardingFormValues>();

    const handleChange = (value: string) => {
        setFieldValue('industry', value);
    }

    return (
        <Stack spacing={2}>
            <Chip
                icon={<Utensils />}
                label="Restaurante"
                color="secondary"
                variant={values.industry === 'restaurant' ? 'filled' : 'outlined'}
                onClick={() => handleChange('restaurant')}
            />
            <Chip
                icon={<Coffee />}
                label="Cafetería"
                color="secondary"
                variant={values.industry === 'coffee-shop' ? 'filled' : 'outlined'}
                onClick={() => handleChange('coffee-shop')}
            />
            <Chip
                icon={<Beer />}
                label="Bar"
                color="secondary"
                variant={values.industry === 'bar' ? 'filled' : 'outlined'}
                onClick={() => handleChange('bar')}
            />
        </Stack>
    )
}

export default OrganizationTypeStep;
